var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src)?_c('div',[_c('top-bar',{on:{"reload":function($event){return _vm.reloadEmpresa()}}}),(_vm.load)?_c('div',{staticClass:"content text-center",staticStyle:{"padding-top":"10vh"}},[_c('loading')],1):_c('div',[_c('web-frame',{attrs:{"src":_vm.src,"auth":_vm.key}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }